export enum SliceNameEnum {
    Accommodation = 'mfeAccommodation',
    AccommodationRatings = 'mfeAccommodationRatings',
    AccommodationStatic = 'mfeAccommodationStatic',
    Autocomplete = 'autocomplete',
    CheckoutDetails = 'mfeCheckoutDetails',
    CheckoutReservation = 'mfeCheckoutReservation',
    CmsGlobal = 'cmsGlobal',
    CmsHomepage = 'cmsHomepage',
    CommonUiState = 'mfeCommonUiState',
    CreatePayment = 'mfeCreatePayment',
    Homepage = 'homepage',
    Listing = 'listing',
    Map = 'map',
    MapAccommodation = 'mapAccommodation',
    ReservationDetails = 'mfeReservationDetails',
    Search = 'search',
    UserProfile = 'appUserProfile',
}
